import { Flex, Box, Heading, Stack, Image, Text } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation } from "swiper";

export default function JoinOurGrowingSection() {
  return (
    <Stack alignItems="center">
      <Heading
        fontSize={{ base: "24px", md: "31px" }}
        pb={{ md: 10 }}
        fontWeight={"semibold"}
        textAlign={{ base: "center" }}
        maxW={{ base: "280px", md: "full" }}
      >
        Join Our Growing Freelance Community
      </Heading>
      <Box width="100%" py={10}>
        <Swiper
          slidesPerView={"4"}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          loop={true}
          breakpoints={{
            // "@0.00": {
            //   slidesPerView: 1,
            //   spaceBetween: 10,
            // },
            // "@0.75": {
            //   slidesPerView: 1,
            //   spaceBetween: 10,
            // },
            "0": {
              slidesPerView: 1,
              spaceBetween: 30,
            },
            "450": {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            "650": {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            "900": {
              slidesPerView: 4,
              spaceBetween: 50,
            },
          }}
          className="mySwiper become-seller-slider"
          navigation={true}
          modules={[Navigation]}
        >
          {data.map((item,index) => {
            return (
              <SwiperSlide key={index}>
                <Box>
                  <Image width="100%" src={item.imageUrl} />
                  <Flex justifyContent="center">
                    <Text
                      // width="170px"
                      fontSize={{ base: "18px", md: "20px" }}
                      fontWeight={"semibold"}
                      p={5}
                      color={{ md: "gray.500" }}
                      align="center"
                    >
                      {item.label}
                    </Text>
                  </Flex>
                </Box>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Box>
    </Stack>
  );
}

const data = [
  {
    label: "I am a Developer",
    imageUrl: "/images/become-a-seller/developer.png",
  },
  {
    label: "I am a Designer",
    imageUrl: "/images/become-a-seller/designer.png",
  },
  {
    label: "I am a Fashion Designer",
    imageUrl: "/images/become-a-seller/fashion.png",
  },
  {
    label: "I am a 3D Artist",
    imageUrl: "/images/become-a-seller/artist.png",
  },
  {
    label: "I am a Developer",
    imageUrl: "/images/become-a-seller/developer.png",
  },
  {
    label: "I am a Designer",
    imageUrl: "/images/become-a-seller/designer.png",
  },
  {
    label: "I am a Fashion Designer",
    imageUrl: "/images/become-a-seller/fashion.png",
  },
  {
    label: "I am a 3D Artist",
    imageUrl: "/images/become-a-seller/artist.png",
  },
];
